import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyRequiresVerification',
  initialState: true,
  reducers: {
    setLoyaltyRequiresVerificationWeb(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyRequiresVerificationWeb } = slice.actions;

export default slice.reducer;
